const permissions = {
  safedriver: 'SD000'
};

export default permissions;
